"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const OpenInNew_1 = tslib_1.__importDefault(require("@mui/icons-material/OpenInNew"));
const Link_1 = tslib_1.__importDefault(require("@mui/material/Link"));
const styles_1 = require("@mui/material/styles");
const OpenInNewTabIcon = (0, styles_1.styled)((props) => react_1.default.createElement(OpenInNew_1.default, { fontSize: "inherit", ...props }))(({ theme }) => ({
    marginLeft: `calc(${theme.spacing(1)} / 2)`,
    verticalAlign: "text-top",
}));
/**
 * This component renders a link, the intended usage is links to other parts of ARGUS
 * If target is specified to be `_blank`, which indicates that the target should
 * be opened in a new tab/window a icon to illustrate this is automatically appended
 * after the link text.
 *
 * Specifying that the link is to be opened in a new tab is some times useful to avoid that analyst's
 * loose all of their context information on the current page.
 *
 * @example Open link in new tab, appends icon. Use createHref from the useHistory hook from history to build internal links
 * ```typescript
 *   <Link target="_blank" href={createHref({path: "/path/to/somewhere"})} />
 *    Link to a special case
 *   </Link>
 * ```
 *
 * @example Regular link with no icon. opens in the current context.Use createHref from the useHistory hook from history to build internal links
 * ```typescript
 *   <Link href={createHref({path: "/path/to/somewhere"})} >
 *    Link to a special case
 *   </Link>
 * ```
 * @category component
 */
const Link = (0, styles_1.styled)(react_1.default.forwardRef(({ target, children, changeColorOnHover, OpenInNewIconProps, ...restProps }, ref) => (react_1.default.createElement(Link_1.default, { underline: "always", target: target, ...restProps, ref: ref },
    children,
    target === "_blank" && react_1.default.createElement(OpenInNewTabIcon, { ...OpenInNewIconProps })))))(({ theme, changeColorOnHover = true }) => ({
    "&:hover": {
        ...(changeColorOnHover && { color: theme.palette.secondary.main }),
    },
}));
exports.default = Link;
